//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class SettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9401";

    }

    getSettings( cancelToken?: CancelToken): Promise<SettingsResponseModel> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<SettingsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettingsResponseModel.fromJS(resultData200);
            return Promise.resolve<SettingsResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingsResponseModel>(null as any);
    }
}

export class SettingsResponseModel implements ISettingsResponseModel {
    urlSettings?: UrlSettings;
    generalSettings?: GeneralSettings;
    featureFlagsSettings?: FeatureFlagsSettings;
    stripeSettings?: StripeSettings;
    oidcSettings?: OidcSettings;

    constructor(data?: ISettingsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlSettings = _data["urlSettings"] ? UrlSettings.fromJS(_data["urlSettings"]) : undefined as any;
            this.generalSettings = _data["generalSettings"] ? GeneralSettings.fromJS(_data["generalSettings"]) : undefined as any;
            this.featureFlagsSettings = _data["featureFlagsSettings"] ? FeatureFlagsSettings.fromJS(_data["featureFlagsSettings"]) : undefined as any;
            this.stripeSettings = _data["stripeSettings"] ? StripeSettings.fromJS(_data["stripeSettings"]) : undefined as any;
            this.oidcSettings = _data["oidcSettings"] ? OidcSettings.fromJS(_data["oidcSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): SettingsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlSettings"] = this.urlSettings ? this.urlSettings.toJSON() : undefined as any;
        data["generalSettings"] = this.generalSettings ? this.generalSettings.toJSON() : undefined as any;
        data["featureFlagsSettings"] = this.featureFlagsSettings ? this.featureFlagsSettings.toJSON() : undefined as any;
        data["stripeSettings"] = this.stripeSettings ? this.stripeSettings.toJSON() : undefined as any;
        data["oidcSettings"] = this.oidcSettings ? this.oidcSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface ISettingsResponseModel {
    urlSettings?: UrlSettings;
    generalSettings?: GeneralSettings;
    featureFlagsSettings?: FeatureFlagsSettings;
    stripeSettings?: StripeSettings;
    oidcSettings?: OidcSettings;
}

export class UrlSettings implements IUrlSettings {
    dashboardServiceUrl?: string;
    dispatcherServiceUrl?: string;
    sensitivityStudiesServiceUrl?: string;
    takeHomeExamsServiceUrl?: string;
    excelRunnerServiceUrl?: string;
    pdfGeneratorServiceUrl?: string;
    usageTrackingServiceUrl?: string;
    aiForPFDServiceUrl?: string;
    dwsimProWebSiteUrl?: string;
    dwsimProRemoteAppUrl?: string;

    constructor(data?: IUrlSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardServiceUrl = _data["dashboardServiceUrl"];
            this.dispatcherServiceUrl = _data["dispatcherServiceUrl"];
            this.sensitivityStudiesServiceUrl = _data["sensitivityStudiesServiceUrl"];
            this.takeHomeExamsServiceUrl = _data["takeHomeExamsServiceUrl"];
            this.excelRunnerServiceUrl = _data["excelRunnerServiceUrl"];
            this.pdfGeneratorServiceUrl = _data["pdfGeneratorServiceUrl"];
            this.usageTrackingServiceUrl = _data["usageTrackingServiceUrl"];
            this.aiForPFDServiceUrl = _data["aiForPFDServiceUrl"];
            this.dwsimProWebSiteUrl = _data["dwsimProWebSiteUrl"];
            this.dwsimProRemoteAppUrl = _data["dwsimProRemoteAppUrl"];
        }
    }

    static fromJS(data: any): UrlSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UrlSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardServiceUrl"] = this.dashboardServiceUrl;
        data["dispatcherServiceUrl"] = this.dispatcherServiceUrl;
        data["sensitivityStudiesServiceUrl"] = this.sensitivityStudiesServiceUrl;
        data["takeHomeExamsServiceUrl"] = this.takeHomeExamsServiceUrl;
        data["excelRunnerServiceUrl"] = this.excelRunnerServiceUrl;
        data["pdfGeneratorServiceUrl"] = this.pdfGeneratorServiceUrl;
        data["usageTrackingServiceUrl"] = this.usageTrackingServiceUrl;
        data["aiForPFDServiceUrl"] = this.aiForPFDServiceUrl;
        data["dwsimProWebSiteUrl"] = this.dwsimProWebSiteUrl;
        data["dwsimProRemoteAppUrl"] = this.dwsimProRemoteAppUrl;
        return data;
    }
}

export interface IUrlSettings {
    dashboardServiceUrl?: string;
    dispatcherServiceUrl?: string;
    sensitivityStudiesServiceUrl?: string;
    takeHomeExamsServiceUrl?: string;
    excelRunnerServiceUrl?: string;
    pdfGeneratorServiceUrl?: string;
    usageTrackingServiceUrl?: string;
    aiForPFDServiceUrl?: string;
    dwsimProWebSiteUrl?: string;
    dwsimProRemoteAppUrl?: string;
}

export class GeneralSettings implements IGeneralSettings {
    environment?: string;
    copilotExampleId?: number | undefined;
    doeExampleId?: number | undefined;
    mssExampleId?: number | undefined;

    constructor(data?: IGeneralSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            this.copilotExampleId = _data["copilotExampleId"];
            this.doeExampleId = _data["doeExampleId"];
            this.mssExampleId = _data["mssExampleId"];
        }
    }

    static fromJS(data: any): GeneralSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        data["copilotExampleId"] = this.copilotExampleId;
        data["doeExampleId"] = this.doeExampleId;
        data["mssExampleId"] = this.mssExampleId;
        return data;
    }
}

export interface IGeneralSettings {
    environment?: string;
    copilotExampleId?: number | undefined;
    doeExampleId?: number | undefined;
    mssExampleId?: number | undefined;
}

export class FeatureFlagsSettings implements IFeatureFlagsSettings {
    openLocalFile?: boolean;
    openInDwsimProWeb?: boolean;
    showCopilot?: boolean;
    showFilterWebForm?: boolean;

    constructor(data?: IFeatureFlagsSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openLocalFile = _data["openLocalFile"];
            this.openInDwsimProWeb = _data["openInDwsimProWeb"];
            this.showCopilot = _data["showCopilot"];
            this.showFilterWebForm = _data["showFilterWebForm"];
        }
    }

    static fromJS(data: any): FeatureFlagsSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlagsSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openLocalFile"] = this.openLocalFile;
        data["openInDwsimProWeb"] = this.openInDwsimProWeb;
        data["showCopilot"] = this.showCopilot;
        data["showFilterWebForm"] = this.showFilterWebForm;
        return data;
    }
}

export interface IFeatureFlagsSettings {
    openLocalFile?: boolean;
    openInDwsimProWeb?: boolean;
    showCopilot?: boolean;
    showFilterWebForm?: boolean;
}

export class StripeSettings implements IStripeSettings {
    unlimitedDwsimProPricingTableId?: string | undefined;
    unlimitedDwsimProPricingTableKey?: string | undefined;
    teamDwsimProPricingTableId?: string | undefined;
    teamDwsimProPricingTableKey?: string | undefined;
    hourlyDwsimProPricingTableId?: string | undefined;
    hourlyDwsimProPricingTableKey?: string | undefined;
    supportPricingTableId?: string | undefined;
    supportPricingTableKey?: string | undefined;
    collaborationPricingTableId?: string | undefined;
    collaborationPricingTableKey?: string | undefined;
    copilotPricingTableId?: string | undefined;
    copilotPricingTableKey?: string | undefined;

    constructor(data?: IStripeSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unlimitedDwsimProPricingTableId = _data["unlimitedDwsimProPricingTableId"];
            this.unlimitedDwsimProPricingTableKey = _data["unlimitedDwsimProPricingTableKey"];
            this.teamDwsimProPricingTableId = _data["teamDwsimProPricingTableId"];
            this.teamDwsimProPricingTableKey = _data["teamDwsimProPricingTableKey"];
            this.hourlyDwsimProPricingTableId = _data["hourlyDwsimProPricingTableId"];
            this.hourlyDwsimProPricingTableKey = _data["hourlyDwsimProPricingTableKey"];
            this.supportPricingTableId = _data["supportPricingTableId"];
            this.supportPricingTableKey = _data["supportPricingTableKey"];
            this.collaborationPricingTableId = _data["collaborationPricingTableId"];
            this.collaborationPricingTableKey = _data["collaborationPricingTableKey"];
            this.copilotPricingTableId = _data["copilotPricingTableId"];
            this.copilotPricingTableKey = _data["copilotPricingTableKey"];
        }
    }

    static fromJS(data: any): StripeSettings {
        data = typeof data === 'object' ? data : {};
        let result = new StripeSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unlimitedDwsimProPricingTableId"] = this.unlimitedDwsimProPricingTableId;
        data["unlimitedDwsimProPricingTableKey"] = this.unlimitedDwsimProPricingTableKey;
        data["teamDwsimProPricingTableId"] = this.teamDwsimProPricingTableId;
        data["teamDwsimProPricingTableKey"] = this.teamDwsimProPricingTableKey;
        data["hourlyDwsimProPricingTableId"] = this.hourlyDwsimProPricingTableId;
        data["hourlyDwsimProPricingTableKey"] = this.hourlyDwsimProPricingTableKey;
        data["supportPricingTableId"] = this.supportPricingTableId;
        data["supportPricingTableKey"] = this.supportPricingTableKey;
        data["collaborationPricingTableId"] = this.collaborationPricingTableId;
        data["collaborationPricingTableKey"] = this.collaborationPricingTableKey;
        data["copilotPricingTableId"] = this.copilotPricingTableId;
        data["copilotPricingTableKey"] = this.copilotPricingTableKey;
        return data;
    }
}

export interface IStripeSettings {
    unlimitedDwsimProPricingTableId?: string | undefined;
    unlimitedDwsimProPricingTableKey?: string | undefined;
    teamDwsimProPricingTableId?: string | undefined;
    teamDwsimProPricingTableKey?: string | undefined;
    hourlyDwsimProPricingTableId?: string | undefined;
    hourlyDwsimProPricingTableKey?: string | undefined;
    supportPricingTableId?: string | undefined;
    supportPricingTableKey?: string | undefined;
    collaborationPricingTableId?: string | undefined;
    collaborationPricingTableKey?: string | undefined;
    copilotPricingTableId?: string | undefined;
    copilotPricingTableKey?: string | undefined;
}

export class OidcSettings implements IOidcSettings {
    authentikBaseUrl?: string;
    oidcAuthority?: string;
    oidcClientId?: string;
    dashboardWebUrl?: string;
    dashboardServiceSlug?: string;

    constructor(data?: IOidcSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authentikBaseUrl = _data["authentikBaseUrl"];
            this.oidcAuthority = _data["oidcAuthority"];
            this.oidcClientId = _data["oidcClientId"];
            this.dashboardWebUrl = _data["dashboardWebUrl"];
            this.dashboardServiceSlug = _data["dashboardServiceSlug"];
        }
    }

    static fromJS(data: any): OidcSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OidcSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authentikBaseUrl"] = this.authentikBaseUrl;
        data["oidcAuthority"] = this.oidcAuthority;
        data["oidcClientId"] = this.oidcClientId;
        data["dashboardWebUrl"] = this.dashboardWebUrl;
        data["dashboardServiceSlug"] = this.dashboardServiceSlug;
        return data;
    }
}

export interface IOidcSettings {
    authentikBaseUrl?: string;
    oidcAuthority?: string;
    oidcClientId?: string;
    dashboardWebUrl?: string;
    dashboardServiceSlug?: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}